var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1121 17.6849C9.98442 17.6858 9.85752 17.6645 9.73713 17.6219C9.61414 17.5768 9.50301 17.5043 9.41213 17.4099L5.11213 13.1099C5.0204 13.0164 4.94954 12.9045 4.9042 12.7816C4.85887 12.6587 4.8401 12.5276 4.84913 12.3969C4.84773 12.1309 4.95121 11.8751 5.13713 11.6849C5.22894 11.5938 5.33839 11.5225 5.45876 11.4752C5.57912 11.4279 5.70787 11.4057 5.83713 11.4099C5.96638 11.4057 6.09513 11.4279 6.2155 11.4752C6.33587 11.5225 6.44531 11.5938 6.53713 11.6849L10.1121 15.2599L18.5871 6.7849C18.7778 6.60434 19.0314 6.50531 19.294 6.50888C19.5565 6.51245 19.8073 6.61835 19.993 6.80403C20.1787 6.98971 20.2846 7.24051 20.2881 7.50308C20.2917 7.76565 20.1927 8.01924 20.0121 8.20991L10.8121 17.4099C10.7212 17.5043 10.6101 17.5768 10.4871 17.6219C10.3667 17.6645 10.2398 17.6858 10.1121 17.6849Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.da4bdbdab764b5cfb7371ad27a1c1a24.svg";
export { ForwardRef as ReactComponent };